import { Directive, HostListener, ElementRef, OnInit, inject } from "@angular/core";

@Directive({ selector: "[appTextareaAutoresize]" })
export class TextareaAutoresizeDirective {
    private el = inject(ElementRef);


    @HostListener(":input")
    onInput() {
        this.resize();
    }

    ngAfterViewChecked(): void {
        if (this.el.nativeElement.scrollHeight) {
            this.resize();
        }
    }

    resize() {
        const initialScrollTop = document.querySelector("html")!.scrollTop;
        // console.log("initialscrolltop", initialScrollTop);
        this.el.nativeElement.style.height = "0";
        this.el.nativeElement.style.height = this.el.nativeElement.scrollHeight + "px";
        document.querySelector("html")!.style.scrollBehavior = "auto";
        document.querySelector("html")!.scrollTop = initialScrollTop;
        document.querySelector("html")!.style.scrollBehavior = "smooth";
    }
}
